<template>
  <v-dialog lazy dark persistent v-model="confirming" content-class="dialog-without-shadow">
    <!-- Activator button -->
    <template #activator="{ on }">
      <slot name="activator" :on="on">
        <v-btn
          v-on="on"
          v-if="!hideActivator"
          @click="validate"
          :color="btnColor"
          :round="btnRound"
          :class="btnClass"
          :icon="hideBtnText"
          :loading="btnLoading"
        >
          <v-icon>{{ btnIcon }}</v-icon>
          <span v-if="!hideBtnText">{{ btnText }}</span>
        </v-btn>
      </slot>
    </template>
    <!-- Text or default slot -->
    <v-layout>
      <v-flex v-if="text" class="headline white--text text-xs-center" v-html="text" />
      <v-flex v-else>
        <slot />
      </v-flex>
    </v-layout>
    <!-- Button -->
    <v-layout>
      <v-flex class="text-xs-center" xs6 sm5 offset-sm1 md2 offset-md4>
        <v-btn icon @click="cancel">
          <v-icon x-large color="error">cancel</v-icon>
        </v-btn>
      </v-flex>
      <v-flex class="text-xs-center" xs6 sm5 md2>
        <v-btn icon @click="confirm">
          <v-icon x-large color="success">check_circle</v-icon>
        </v-btn>
      </v-flex>
    </v-layout>
  </v-dialog>
</template>

<script>
export default {
  props: {
    btnClass: { type: String },
    btnColor: { type: String },
    btnIcon: { type: String },
    btnLoading: { type: Boolean },
    btnRound: { type: Boolean },
    btnText: { type: String },
    hideBtnText: { type: Boolean },
    hideActivator: { type: Boolean },
    text: { type: String },
    /* You can pass a validator function to prevent opening the dialog if this function returns false.
     * Is up to you handling if the validation fails, in this case this component will emit 'validate:fail'. */
    validator: { type: Function },
    /* Value to use as v-model */
    value: {}
  },
  data() {
    return {
      confirming: this.value
    };
  },
  watch: {
    confirming() {
      this.$emit("input", this.confirming);
      if (this.confirming) {
        setTimeout(() => {
          const element = document.getElementsByClassName("v-overlay")[0];
          element.className += " black-overlay";
        }, 0);
      }
    },
    value() {
      this.confirming = this.value;
    }
  },
  methods: {
    validate(event) {
      if (this.validator && !this.validator()) {
        event.stopPropagation();
        this.$emit("validate:fail");
      }
    },
    confirm() {
      this.confirming = false;
      this.$emit("confirm");
    },
    cancel() {
      this.confirming = false;
      this.$emit("cancel");
    }
  }
};
</script>

<style>
.dialog-without-shadow {
  box-shadow: none;
}

.black-overlay.v-overlay--active:before {
  opacity: 0.9;
  transition: all 0.1s;
}
</style>
